/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimeSeries } from './TimeSeries';
import {
    TimeSeriesFromJSON,
    TimeSeriesFromJSONTyped,
    TimeSeriesToJSON,
} from './TimeSeries';
import type { SeriesValuesRequestSearchAfter } from './SeriesValuesRequestSearchAfter';
import {
    SeriesValuesRequestSearchAfterFromJSON,
    SeriesValuesRequestSearchAfterFromJSONTyped,
    SeriesValuesRequestSearchAfterToJSON,
} from './SeriesValuesRequestSearchAfter';

/**
 * 
 * @export
 * @interface SeriesValuesRequestSeries
 */
export interface SeriesValuesRequestSeries {
    /**
     * 
     * @type {string}
     * @memberof SeriesValuesRequestSeries
     */
    requestId: string;
    /**
     * 
     * @type {SeriesValuesRequestSearchAfter}
     * @memberof SeriesValuesRequestSeries
     */
    searchAfter?: SeriesValuesRequestSearchAfter;
    /**
     * 
     * @type {TimeSeries}
     * @memberof SeriesValuesRequestSeries
     */
    series: TimeSeries;
}

/**
 * Check if a given object implements the SeriesValuesRequestSeries interface.
 */
export function instanceOfSeriesValuesRequestSeries(value: object): value is SeriesValuesRequestSeries {
    if (!('requestId' in value) || value['requestId'] === undefined) return false;
    if (!('series' in value) || value['series'] === undefined) return false;
    return true;
}

export function SeriesValuesRequestSeriesFromJSON(json: any): SeriesValuesRequestSeries {
    return SeriesValuesRequestSeriesFromJSONTyped(json, false);
}

export function SeriesValuesRequestSeriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeriesValuesRequestSeries {
    if (json == null) {
        return json;
    }
    return {
        
        'requestId': json['requestId'],
        'searchAfter': json['searchAfter'] == null ? undefined : SeriesValuesRequestSearchAfterFromJSON(json['searchAfter']),
        'series': TimeSeriesFromJSON(json['series']),
    };
}

export function SeriesValuesRequestSeriesToJSON(value?: SeriesValuesRequestSeries | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'requestId': value['requestId'],
        'searchAfter': SeriesValuesRequestSearchAfterToJSON(value['searchAfter']),
        'series': TimeSeriesToJSON(value['series']),
    };
}

